<template>
  <span>
    <template v-if="prepend">{{ prepend }}</template>
    <span class="date">
      <span class="date__tooltip">{{ date | format(format) }}</span>
      {{ moment }}
    </span>
    <template v-if="append">{{ append }}</template>
  </span>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'app-date',
  props: {
    date: {
      type: String,
    },
    format: {
      type: String,
    },
    prepend: {
      type: String,
    },
    append: {
      type: String,
    },
  },
  computed: {
    moment() {
      return moment.utc(this.date).fromNow();
    },
  },
};
</script>

<style lang="scss" scoped>
.date {
  position: relative;
  &:hover {
    .date__tooltip {
      opacity: 1;
      transform: translateY(-100%);
    }
  }

  &__tooltip {
    color: white;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.95);
    position: absolute;
    opacity: 0;
    padding: 0.125rem;
    white-space: nowrap;
    transition: all 128ms ease-in-out;
  }
}
</style>
